<form [formGroup]="form" (ngSubmit)="submit()">
  <h2 mat-dialog-title>Posponer Notificaci&oacute;n</h2>
  <mat-dialog-content class="mat-typography">
    <mat-form-field>
      <mat-label>Fecha Pospuesta</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="fecha" [min]="minDate">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close class="btn-secondary" type="button">Cancel</button>
    <button mat-button cdkFocusInitial class="btn-primary" [disabled]="form.invalid">Aceptar</button>
  </mat-dialog-actions>
</form>
